import React, { useState } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditPositionComp from '../../components/version-4/MasterForms/EditForms/EditPositionComp'
import { usePosition } from '../../hooks/CompanyConfiguration/usePosition'
import { ROUTES } from '../../shared/constants'
import PositionForm from '../Masters/PositionForm'

function EditPosition() {
  const { position, getPosition } = usePosition()
  const [formPopup, setFormPopup] = useState(false)
  // const handlePosition = () => {
  //     setFormPopup(false);
  // }
  //  const handlePositionOpen = () => {
  //     setFormPopup(true);
  // }
  const params = useParams()

  const { addPosition, updatePosition } = usePosition()
  const [positionData, setPositionData] = useState({
    name: '',
    rank: '',
    positionCode: '',
  })
  const handlePosition = () => {
    updatePosition({
      positionName: positionData.name,
      rank: positionData.rank,
      positionId: params.positionId,
      positionCode: positionData.positionCode,
    })
  }
  React.useEffect(() => {
    getPosition({ positionId: params.positionId })
  }, [params.positionId])

  React.useEffect(() => {
    setPositionData({
      name: position.positionName,
      positionCode: position.positionCode,
      rank: position.rank,
    })
  }, [position])

  return <>{position ? <PositionForm position={position} /> : <Loader />}</>
}

export default EditPosition
